/* global G */
import ui from 'lib/hook/ui/update'
import recall from 'app/_shared/hook/component/recall'

const _listHooks = {
  before: [
    recall,
  ],
  after: [
    ui,
  ],
}

const hooks = {
  [G.ACTIONS]: {
    index: _listHooks,
  },
}

export default hooks
